import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tag", "checkmark", "plus"]

  toggle(event) {
    const checkbox = event.target
    const label = checkbox.closest('label')
    const checkmark = label.querySelector('[data-tag-selector-target="checkmark"]')
    const plus = label.querySelector('[data-tag-selector-target="plus"]')
    
    if (checkbox.checked) {
      label.classList.remove('bg-gray-100', 'text-gray-700', 'hover:bg-gray-200')
      label.classList.add('bg-blue-100', 'text-blue-800', 'hover:bg-blue-200')
      checkmark.classList.remove('hidden')
      checkmark.classList.add('block')
      plus.classList.add('hidden')
      plus.classList.remove('block')
      label.dataset.selected = 'true'
    } else {
      label.classList.add('bg-gray-100', 'text-gray-700', 'hover:bg-gray-200')
      label.classList.remove('bg-blue-100', 'text-blue-800', 'hover:bg-blue-200')
      checkmark.classList.add('hidden')
      checkmark.classList.remove('block')
      plus.classList.remove('hidden')
      plus.classList.add('block')
      label.dataset.selected = 'false'
    }
  }
}